import { render, staticRenderFns } from "./SpinnerWithParams.vue?vue&type=template&id=253a2374&"
import script from "./SpinnerWithParams.vue?vue&type=script&lang=js&"
export * from "./SpinnerWithParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports